/**
 * @deprecated Use `src/design-system/tokens.ts` instead.
 * This file is kept for backward compatibility during migration.
 * New code should import from `@/design-system` or `../design-system/tokens`.
 */
export const COLORS = {
  // Core brand colors
  primary: '#1da1f2',      // Main blue (matches "Play Again" button)
  primaryLight: '#eaf6fd', // Light blue background
  accent: '#0099ff',       // Accent blue for highlights
  correct: '#43e97b',      // Emerald for correct answers
  incorrect: '#f44336',    // Red for incorrect
  error: '#f44336',        // Error color (matches incorrect)
  text: '#222',
  textLight: '#666',
  background: '#fff',
  buttonText: '#fff',
  buttonDisabled: '#b3e0fc',
  border: '#e2e8f0',

  // Gradients
  gradientPrimary: ['#43e97b', '#38f9d7'] as const, // Emerald to mint
  gradientSecondary: ['#FFD700', '#FFB347'] as const, // Gold to orange
  gradientBlue: ['#1da1f2', '#0099ff'] as const, // Blue gradient
  gradientCard: ['rgba(255,255,255,0.80)', 'rgba(234,246,253,0.85)'] as const, // Glassy card

  // Glassmorphism backgrounds
  glass: 'rgba(255,255,255,0.60)',
  glassDark: 'rgba(30,40,70,0.62)',

  // Glow/Shadow colors
  glowGold: '#FFD700',
  glowEmerald: '#43e97b',
  glowBlue: '#1da1f2',
  glowRed: '#f44336',
};
